import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { IconButton } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useEffect, useState } from 'react'
import useDebounce from '../../hooks/useDebounce'
import { MAX_WHOLESALE_PRODUCT_QTY } from '../../../constants'
import { OutOfStockStatusEnum } from '../../../generated/gqlTypes'

const useStyles = makeStyles(() => ({
  iconButton: {
    borderRadius: 0,
  },
}))

interface IProps {
  qty: number
  stockQty: number
  outOfStockStatus?: OutOfStockStatusEnum | null
  canEdit: boolean

  handleEditQty?(qty: number): void
}

const CartLineQtyWidget: React.FC<IProps> = ({ qty, stockQty, outOfStockStatus, canEdit, handleEditQty }) => {
  const classes = useStyles()
  const [localQty, setLocalQty] = useState<string>(qty.toString())

  useEffect(() => {
    setLocalQty(qty.toString())
  }, [qty])

  // outOfStockStatus is the merchant's stock-tracking policy for this variant/product: IN or
  // BACKORDER means stock isn't tracked for sales purposes, so only MAX_WHOLESALE_PRODUCT_QTY applies.
  const isUnlimited =
    outOfStockStatus === OutOfStockStatusEnum.In || outOfStockStatus === OutOfStockStatusEnum.Backorder
  const maxQty = isUnlimited ? MAX_WHOLESALE_PRODUCT_QTY : stockQty

  const handleChangeQtyDebounced = useDebounce(handleEditQty, 1000)
  const handleChangeQty = (qty: string) => {
    setLocalQty(qty)
    if (qty !== '' && +qty > 0 && +qty <= maxQty) {
      handleChangeQtyDebounced(+qty)
    } else if (+qty > maxQty) {
      setLocalQty(maxQty.toString())
      handleChangeQtyDebounced(maxQty)
    }
  }
  return (
    <div
      className='flex items-center justify-center w-120 h-[36px] px-10'
      style={{ border: canEdit ? 'solid 1px #ccc' : '', borderRadius: '5px' }}
    >
      {canEdit && (
        <IconButton
          className={classes.iconButton}
          size='small'
          onClick={() => handleChangeQty((+localQty - 1).toString())}
          disabled={localQty === '' || +localQty < 2}
          disableRipple
        >
          <RemoveIcon className='p-5' fontSize='inherit' style={{ width: 22, height: 22 }} />
        </IconButton>
      )}
      <span className='flex-1 appearance-none'>
        <input
          className='max-w-full w-40 text-center border-0 bg-white'
          type='number'
          value={localQty}
          onChange={event => {
            handleChangeQty(event.target.value)
          }}
          disabled={!canEdit}
        />
      </span>
      {canEdit && (
        <IconButton
          className={classes.iconButton}
          size='small'
          onClick={() => handleChangeQty((+localQty + 1).toString())}
          disabled={localQty === '' || maxQty <= +localQty}
          disableRipple
        >
          <AddIcon className='p-2' fontSize='inherit' style={{ width: 22, height: 22 }} />
        </IconButton>
      )}
    </div>
  )
}

export default CartLineQtyWidget
